import React, { useEffect } from 'react'
import Walletbanner from './Walletbanner/Walletbanner'
import Header from '../landing/Header/Header'
import Cryptocommand from './Cryptocommand/Cryptocommand'
import Multichain from './Multichain/Multichain'
import Choosewallet from './Choosewallet/Choosewallet'
import Evolve from './Evolvetomi/Evolve'
import Experience from './Experience/Experience'
import Footer from '../landing/footer/Footer'

const Walletlanding = () => {
  useEffect(() => {
      window.scrollTo(0, 0)
    }, [])
  return (
    <>
    <Header/>
    <Walletbanner/>
    <Cryptocommand/>
    <Multichain/>
    <Choosewallet/>
    <Evolve/>
    <Experience/>
    <Footer/>
    </>
  )
}

export default Walletlanding